import React, { useContext, useEffect, useReducer, useMemo } from 'react';
import { Box, IconButton, Tooltip, TextField } from '@mui/material';
import Table, { TableHook } from '../Table';
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import { externalComponent } from '../AppRoutes';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../Utils/ConfirmationDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditTransportadoras from './editTransportadoras';
import { NumericFormat } from 'react-number-format';
import ColorButton from '../Buttons/ColorButton';
import MegaAutoComplete from '../Utils/megautocomplete';

const getcolumns = (setState, state) => {
    const columns = []

    columns.push({ field: 'uf', headerName: 'Estado', width: 80 })
    columns.push({
        field: 'nome', headerName: 'Nome', flex: 0.7,
        renderCell: (props) => {
            return (
                <Box>
                    {props.row.nome_rota_regiao} - {props.row.transportadora}
                </Box>
            )
        }
    })
    columns.push({
        field: 'cobrado', headerName: '% Cobrado', width: 150,
        renderCell: ({ value }) => {
            return (
                <Box>
                    <NumericFormat
                        value={value}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        suffix="%"
                        fixedDecimalScale
                    />
                </Box>
            )
        }
    })
    columns.push({
        field: 'frete_minimo', headerName: 'Frete Mínimo', width: 130,
        renderCell: ({ value }) => {
            return (
                <Box>
                    <NumericFormat
                        value={value}
                        displayType="text"
                        prefix="R$ "
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                    />
                </Box>
            )
        }
    })
    columns.push({
        field: 'empresa',
        headerName: 'Empresa',
        flex: 1,
        renderCell: (params) => {

            const ids = params.row.id_empresas?.split(',').map(Number) || [];
            const descricoes = ids
                .map(id => state.empresas.find(e => e.Cod === id)?.Descricao)
                .filter(Boolean); // remove undefined caso não ache

            return (
                <Box>
                    {descricoes.join(', ')}
                </Box>
            );
        }
    })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar tabela'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Deleta tabela'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })


    return columns
}

const getTransportadoras = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.post(`/frete/transportadora/`)
    if (res.status === 200) {
        setState({ rows: res.data, rowsReset: res.data })
    }
    setLoader(false)
}

const getEmpresas = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/frete/transportadora/empresas/`)
    if (res.status === 200) {
        setState({ empresas: res.data })
    }
    setLoader(false)
}

const deleteTransportadora = async (setLoader, setState, getTables, id) => {
    setLoader(true)
    const res = await api.post(`/frete/transportadora/${id}`)
    if (res.status === 200) {
        await getTables(setLoader, setState)
        setState({ deleteRow: null })
    }
    setLoader(false)
}

const filterRows = (setState, state) => {
    const nome = state.nameFilter || '';
    const estado = state.estadoFilter || '';
    const empresasSelecionadas = state.empresaFilter || []; // array de objetos { id, label }

    const filtered = (state.rowsReset || []).filter(each => {
        // filtros já existentes
        const matchNomeOuTransportadora =
            (each.nome_rota_regiao || '').toLowerCase().includes(nome.toLowerCase()) ||
            (each.transportadora || '').toLowerCase().includes(nome.toLowerCase());
        const matchEstado = (each.uf || '').toLowerCase().includes(estado.toLowerCase());

        // novo filtro de empresa
        let matchEmpresa = true;
        if (empresasSelecionadas.length > 0) {
            const idsRow = (each.id_empresas || '')
                .split(',')
                .map(id => parseInt(id.trim(), 10));

            // se pelo menos um dos ids selecionados estiver presente no row
            matchEmpresa = empresasSelecionadas.some(emp => idsRow.includes(emp.id));
        }

        return matchNomeOuTransportadora && matchEstado && matchEmpresa;
    });

    setState({ rows: filtered });
};

const clearFilters = (state, setState) => {
    setState({ rows: state.rowsReset, estadoFilter: '', nameFilter: '', empresaFilter: [] })
}

const Transportadoras = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rowsReset: [],
        estadoFilter: '',
        nameFilter: '',
        empresaFilter: [],
        empresas: [],
        editRow: null,
        deleteRow: null
    })

    const { setLoader } = useContext(externalComponent)

    const [table] = TableHook()

    const reloadData = () => {
        getTransportadoras(setLoader, setState)
    }

    useEffect(() => {
        getTransportadoras(setLoader, setState)
        getEmpresas(setLoader, setState)
    }, [])

    return (
        <>

            {
                state.editRow &&
                <EditTransportadoras
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    setLoader={setLoader}
                />
            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir a Transportadora ${state.deleteRow.nome_rota_regiao} - ${state.deleteRow.transportadora} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteTransportadora(setLoader, setState, getTransportadoras, state.deleteRow.id)}
                />

            }


            <Box className='nfsentrada-mainframe'>

                <Box sx={{ flex: .15 }} className='nfsentrada-filters'>

                    <Box className='filter-items'>
                        <TextField
                            id="estadoFilter"
                            type="text"
                            label="Estado"
                            size='small'
                            value={state.estadoFilter}
                            onChange={(e) => { setState({ 'estadoFilter': e.target.value }) }}
                            fullWidth={false}
                            sx={{ width: '17rem' }}
                        />

                        <TextField
                            id="nameFilter"
                            type="text"
                            label="Nome"
                            size='small'
                            value={state.nameFilter}
                            onChange={(e) => { setState({ 'nameFilter': e.target.value }) }}
                            fullWidth={false}
                            sx={{ width: '17rem' }}
                        />



                        <Box sx={{ width: '25rem' }}>
                            <MegaAutoComplete

                                id="empresaFilter"
                                multiple={true}
                                value={state.empresaFilter}
                                onChange={(data) => { setState({ empresaFilter: data }) }}
                                noOptionsText={'Digite para procurar uma empresa'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Empresa'

                            />
                        </Box>


                    </Box>

                    <Box className='filter-buttons'>

                        <ColorButton onClick={() => filterRows(setState, state)}> Localizar </ColorButton>
                        <ColorButton onClick={() => clearFilters(state, setState)}> Limpar filtros </ColorButton>

                    </Box>

                </Box>


                <Box sx={{ flex: .85, minHeight: 0 }}>
                    <Table
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumns(setState, state), [state.rows, state.edit, state.empresas])}
                        pagination={false}
                        toolbar
                        slots={{
                            addComponent: () => setState({ editRow: {} }),
                            columnComponent: true
                        }}
                        rowHeight={30}
                        innerRef={table}

                        nameTable='tableTransportadora'
                    />
                </Box>

            </Box>



        </>
    )
}

export default Transportadoras;
